module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-category5.6578e873.svg";